<template>
  <div class="d-flex w-100 h-100">
    <Navbar />
    <div
      id="content"
      class="flex-grow-1"
    >
      <div class="container-fluid p-4 position-relative">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
  import Navbar from "../Navbar.vue";

  export default {
    name: "OnTheRoad",
    components: {
      Navbar,
    },
  };
</script>
